import React from "react";

/*
*  Responsive photo from public/images. Each photo is saved as {name}-{width}.webp for every width in "widths",
*  plus {name}-{fallbackWidth}.jpg for the few browsers without WebP support.
*/
const Picture = ({ name, widths, fallbackWidth, sizes, alt, width, height, className, eager }) => {
  const webpSrcSet = widths.map((w) => `/images/${name}-${w}.webp ${w}w`).join(", ");
  const fallbackSrc = fallbackWidth ? `/images/${name}-${fallbackWidth}.jpg` : `/images/${name}-${widths[widths.length - 1]}.webp`;

  return (
    <picture>
      <source
        type={"image/webp"}
        srcSet={webpSrcSet}
        sizes={sizes}
      />
      <img
        className={className}
        src={fallbackSrc}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? "eager" : "lazy"}
        decoding={"async"}
        // eslint-disable-next-line react/no-unknown-property -- React 18 only passes the attribute through in lowercase
        fetchpriority={eager ? "high" : "auto"}
      />
    </picture>
  );
};

export default Picture;
